import { styled } from 'baseui';
import { Card } from 'baseui/card';

export const PanelTitle = styled('div', ({ $theme, $gap = '16px' }) => ({
  display: 'flex',
  gap: $gap,
  lineHeight: '30px',
  [`@media screen and (min-width: 768px)`]: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  fontSize: '20px',
  flexDirection: 'column',
}));

export const RoleTag = styled('div', ({ $theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '4px 12px',
  gap: '8px',
  color: $theme.colors.textSecondary,
  backgroundColor: $theme.colors.lightGreyColor2,
  borderRadius: '8px',
  fontSize: '14px',
  fontWeight: 400,

  'svg': {
    flexShrink: 0
  }
}));

export const PanelContent = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
});

export const ButtonGroup = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  '@media screen and (min-width: 744px)': {
    flexDirection: 'row',
  },
});

export const ButtonWrapper = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',

  '@media screen and (min-width: 428px)': {
    gap: '8px',
  }
});

export const ButtonIcon = styled('div', ({ $variant, $theme }) => ({
  width: '24px',
  height: '24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '100px',
  flexShrink: 0,
  flexDirection: 'column',
  backgroundColor:
    $variant === 'icon'
      ? $theme.colors.primaryButtonColor
      : $theme.colors.blackColor1,
  color: $variant === 'number' ? $theme.colors.whiteColor : undefined,
  fontSize: $variant === 'number' ? '14px' : undefined,
}));

export const BannerWrapper = styled('div', {
  width: '100%',
});

export const BannerTitle = styled('div', ({ $theme }) => ({
  fontWeight: 500,
  color: $theme.colors.notificationInfoText,
}));

export const BannerContent = styled('div', {
  display: 'flex',
  flexDirection: 'column',
});

export const IntroPanelTitle = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const IntroIconWrapper = styled('span', {
  width: '32px',
  height: '32px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const CardsContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  width: '100%',
  '@media screen and (min-width: 744px)': {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '24px',
  },
  '@media screen and (min-width: 1024px)': {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    '& > *': {
      flex: '1',
    }
  },
  '&.programmable': {
    '@media screen and (min-width: 428px) and (max-width: 767px)': {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '24px',
    },
    '@media screen and (min-width: 1024px)': {
      display: 'flex',
    }
  }
});

export const StyledCard = styled(Card, {
  alignSelf: 'stretch',
  borderRadius: '8px',
  border: '1px solid #EDEDED',
  backgroundColor: '#FFFFFF',
  minHeight: '182px',

  '@media screen and (min-width: 1024px)': {
      flex: '1 0 0',
    }
});

export const CardsHeader = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  gap: '8px',
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '25.6px'
})